import React, { useContext, useState } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";
import showAlert from "utils/showAlert";

export default function AccountIds() {
  const context = useContext(SettingsContext);

  let shopifyIcon = require("images/lite/icons/shopify.png");
  let shopifyIconWhite = <img className="platform-icon shop-icon-white filter-white" src={`/datapulse${shopifyIcon}`} />;
  shopifyIcon = <img className="platform-icon" src={`/datapulse${shopifyIcon}`} />;
  let googleAds = require("images/lite/icons/google-ads.png");
  googleAds = <img className="platform-icon" src={`/datapulse${googleAds}`} />;
  let microsoftAds = require("images/lite/icons/microsoft-ads.png");
  microsoftAds = <img className="platform-icon" src={`/datapulse${microsoftAds}`} />;
  let metaAds = require("images/lite/icons/meta.png");
  metaAds = <img className="platform-icon" src={`/datapulse${metaAds}`} />;
  let tiktokAds = require("images/lite/icons/tiktok.png");
  tiktokAds = <img className="platform-icon" src={`/datapulse${tiktokAds}`} />;
  let GoogleAnalytics = require("images/lite/icons/google-analytics.png");
  GoogleAnalytics = <img className="platform-icon" src={`/datapulse${GoogleAnalytics}`} />;
  let semrush = require("images/lite/icons/semrush.png");
  semrush = <img className="platform-icon" src={`/datapulse${semrush}`} />;
  let amazonAdsIcon = require("images/lite/icons/amazon-icon.png");
  amazonAdsIcon = <img className="platform-icon" src={`/datapulse${amazonAdsIcon}`} />;
  let amazonSellerIcon = require("images/lite/icons/amazon-seller.png");
  amazonSellerIcon = <img className="platform-icon" src={`/datapulse${amazonSellerIcon}`} />;
  let googleSheetsIcon = require("images/lite/icons/google-sheets.png");
  googleSheetsIcon = <img className="platform-icon" src={`/datapulse${googleSheetsIcon}`} />;
  let mailchimpIcon = require("images/lite/icons/mailchimp.png");
  mailchimpIcon = <img className="platform-icon filter-grey" src={`/datapulse${mailchimpIcon}`} />;

  let microsoftExample = require("images/onboarding/microsoft-example.png");
  microsoftExample = <img className="pt-3" src={`/datapulse${microsoftExample}`} />;
  const microsoftMessage = <div>Account IDs must be taken from the URL. Select the account from the initial list of accounts, then check the url for the "aid" parameter. The account id directly follows the = symbol. {microsoftExample}</div>

  let projectIdImg = require("images/semrush-project-id.jpg");
  projectIdImg = <img  src={`/datapulse${projectIdImg}`} />;
  const semrushExample = <div>The ID can change if a new target location has been selected. To make sure the ID is correct, open the project in SEMRush, and in the 'Position Tracking' tile, select 'View full report'. Copy the ID from the URL.<br></br>{projectIdImg}</div>

  const authenticateShopifyFunction = () => {
    const paramsObject = {
      shopify_url: shopifyUrl,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify/authenticate",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        window.open(data.permission_url, "_blank");
      },
    });
    console.log("Started Shopify authentication flow")
  };

  const resetShopifyToken = () => {
    let myObject = {
      shopify_token: "",
      client_account_id: context.client_account.id,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify/reset-token",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(myObject),
    });
    console.log("Reset Shopify authentication")
  };

  const [facebookObjective, setFacebookObjective] = useState(jsDig(["facebookObjective"], context) || '');
  const [tiktokObjective, setTiktokObjective] = useState(jsDig(["tiktokObjective"], context) || '');
  const [semrushTargetLocation, setSemrushTargetLocation] = useState(jsDig(["semrushTargetLocation"], context) || '');
  const [shopifyRevenueType, setShopifyRevenueType] = useState(jsDig(["shopifyRevenueType"], context) || '');
  const [shopifyCountryFilter, setShopifyCountryFilter] = useState(jsDig(["shopifyCountryFilter"], context) || '');
  const [googleAdsId, setGoogleAdsId] = useState(jsDig(["googleAdsId"], context) || '');
  const [microsoftId, setMicrosoftId] = useState(jsDig(["microsoftId"], context) || '');
  const [metaId, setMetaId] = useState(jsDig(["metaId"], context) || '');
  const [tiktokId, setTiktokId] = useState(jsDig(["tiktokId"], context) || '');
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState(jsDig(["googleAnalyticsId"], context) || '');
  const [semrushId, setSemrushId] = useState(jsDig(["semrushId"], context) || '');;
  const [amazonAdsId, setAmazonAdsId] = useState(jsDig(["amazonAdsId"], context) || '');
  const [amazonSellerCountry, setAmazonSellerCountry] = useState(jsDig(["amazonSellerCountry"], context) || '');
  const [shopifyUrl, setShopifyUrl] = useState(jsDig(["shopifyUrl"], context) || '');
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(jsDig(["googleSheetsUrl"], context) || '');
  const [mailchimpServerPrefix, setMailchimpServerPrefix] = useState(jsDig(["mailchimpServerPrefix"], context) || '');
  
  // onChange handlers
  const handleFacebookObjectiveChange = (e) => {
    const targetValue = e.target.value;
    setFacebookObjective(targetValue);
    context.setFacebookObjective(targetValue);
  };
  const handleTiktokObjectiveChange = (e) => {
    const targetValue = e.target.value;
    setTiktokObjective(targetValue);
    context.setTiktokObjective(targetValue);
  };
  const handleSemrushTargetLocationChange = (e) => {
    const targetValue = e.target.value;
    setSemrushTargetLocation(targetValue);
    context.setSemrushTargetLocation(targetValue);
  };
  const handleShopifyRevenueTypeChange = (e) => {
    const targetValue = e.target.value;
    setShopifyRevenueType(targetValue);
    context.setShopifyRevenueType(targetValue);
  };
  const handleShopifyCountryFilterChange = (e) => {
    const targetValue = e.target.value;
    setShopifyCountryFilter(targetValue);
    context.setShopifyCountryFilter(targetValue);
  };
  const handleGoogleAdsIdChange = (e) => setGoogleAdsId(e.target.value);
  const handleMicrosoftIdChange = (e) => setMicrosoftId(e.target.value);
  const handleMetaIdChange = (e) => setMetaId(e.target.value);
  const handleTiktokIdChange = (e) => setTiktokId(e.target.value);
  const handleGoogleAnalyticsIdChange = (e) => setGoogleAnalyticsId(e.target.value);
  const handleSemrushIdChange = (e) => setSemrushId(e.target.value);
  const handleShopifyUrlChange = (e) => setShopifyUrl(e.target.value);
  const handleAmazonAdsIdChange = (e) => setAmazonAdsId(e.target.value);
  const handleAmazonSellerCountryChange = (e) => {
    const targetValue = e.target.value;
    setAmazonSellerCountry(targetValue);
    context.setAmazonSellerCountry(targetValue);
  };
  const handleGoogleSheetsUrlChange = (e) => setGoogleSheetsUrl(e.target.value);
  const handleMailchimpServerPrefixChange = (e) => setMailchimpServerPrefix(e.target.value);

  // onBlur handlers to update the context
  const handleGoogleAdsIdBlur = () => context.setGoogleAdsId(googleAdsId);
  const handleMicrosoftIdBlur = () => context.setMicrosoftId(microsoftId);
  const handleMetaIdBlur = () => context.setMetaId(metaId);
  const handleTiktokIdBlur = () => context.setTiktokId(tiktokId);
  const handleGoogleAnalyticsIdBlur = () => context.setGoogleAnalyticsId(googleAnalyticsId);
  const handleSemrushIdBlur = () => context.setSemrushId(semrushId);
  const handleShopifyUrlBlur = () => context.setShopifyUrl(shopifyUrl);
  const handleAmazonAdsIdBlur = () => context.setAmazonAdsId(amazonAdsId);
  const handleGoogleSheetsUrlBlur = () => context.setGoogleSheetsUrl(googleSheetsUrl);
  const handleMailchimpServerPrefixBlur = () => context.setMailchimpServerPrefix(mailchimpServerPrefix);

  const amazonSellerCountries = [
    { name: "United States", value: "US" },
    { name: "Canada", value: "CA" },
    { name: "Mexico", value: "MX" },
    { name: "Brazil", value: "BR" },
    { name: "United Kingdom", value: "UK" },
    { name: "Germany", value: "DE" },
    { name: "France", value: "FR" },
    { name: "Italy", value: "IT" },
    { name: "Spain", value: "ES" },
    { name: "Netherlands", value: "NL" },
    { name: "Sweden", value: "SE" },
    { name: "Poland", value: "PL" },
    { name: "Turkey", value: "TR" },
    { name: "Australia", value: "AU" },
    { name: "Japan", value: "JP" },
    { name: "India", value: "IN" },
    { name: "Singapore", value: "SG" },
    { name: "United Arab Emirates", value: "AE" },
    { name: "Saudi Arabia", value: "SA" },
    { name: "Egypt", value: "EG" },
    { name: "South Africa", value: "ZA" },
    { name: "Belgium", value: "BE" },
  ];

  const authorizeAmazonSeller = () => {
    window.open(`/datapulse/amazon-seller/oauth/authorize?country=${amazonSellerCountry}&platform=amazon_seller`, "_blank");
    document.querySelector("#amazon-seller-reload-msg").style.display = "block";
  };

  const deauthorizeAmazonSeller = async (id, el) => {
    const response = await fetch(`/datapulse/amazon-seller/oauth/deauthorize`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ credential_id: id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        el.closest(".amazon-seller-authentication").remove();
        showAlert("Amazon Seller deauthorized successfully");
      } else {
        showAlert("Failed to deauthorize Amazon Seller.\n" + data.error);
      }
    }
  };

  const pullGoogleSheetsData = async (e) => {
    const button = e.target;
    // disable the button and add a buffering icon
    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Pulling data...';
    const response = await fetch(`/datapulse/lite-config/pull-google-sheets-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ client_account_id: context.client_account.id }),
    });
    if (response.ok) {
      const data = await response.json();
      console.log(data)
      if (data.success) {
        showAlert("Google Sheets data pulled successfully");
        button.innerHTML = "Pull data";
      } else {
        showAlert("Failed to pull Google Sheets data.\n" + data.message);
        button.innerHTML = "Pull data";
        button.disabled = false;
      }
    }
  }

  const deleteGoogleSheetsData = async () => {
    const response = await fetch(`/datapulse/lite-config/delete-google-sheets-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ client_account_id: context.client_account.id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        showAlert("Google Sheets data deleted successfully");
      }
    }
  }

  const authorizeMailchimp = async () => {
    window.open(`/datapulse/mailchimp/oauth/authorize?platform=mailchimp`, "_blank");
    document.querySelector("#mailchimp-reload-msg").style.display = "block";
  }

  const deauthorizeMailchimp = async (id, el) => {
    const response = await fetch(`/datapulse/mailchimp/oauth/deauthorize`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ credential_id: id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        showAlert("Mailchimp deauthorized successfully");
      } else {
        showAlert("Failed to deauthorize Mailchimp.\n" + data.error);
      }
    }
  }

  return (
    <div className="lite-acc-id-container">
      <div className="grid-container">
        <div className="grid-item google-analytics">
          <div className="grid-item-header">
            {GoogleAnalytics} <p>Google Analytics</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">Google Analytics ID</p>
            <input
              type="text"
              id="googleAnalyticsId"
              name="google_analytics_id"
              value={googleAnalyticsId}
              onChange={handleGoogleAnalyticsIdChange}
              onBlur={handleGoogleAnalyticsIdBlur}></input>
          </div>
        </div>
        <div className="grid-item google-ads">
          <div className="grid-item-header">
            {googleAds} <p>Google Ads</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">Google Ads ID</p>
            <input
              type="text"
              id="googleAdsId"
              name="google_ads_id"
              value={googleAdsId}
              onChange={handleGoogleAdsIdChange}
              onBlur={handleGoogleAdsIdBlur}></input>
          </div>
        </div>
        <div className="grid-item microsoft-ads">
          <div className="grid-item-header">
            {microsoftAds} <p>Microsoft Ads</p>
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Microsoft Ads ID
            </p>
            <CustomTooltip  
              className="d-inline"
              faClass="far fa-question-circle pl-2"
              message= {microsoftMessage}
              style={{display: "inline"}}
              inline={true}
            /> 
            <input
              type="text"
              id="microsoftId"
              name="microsoft_id"
              value={microsoftId}
              onChange={handleMicrosoftIdChange}
              onBlur={handleMicrosoftIdBlur}></input>
          </div>
        </div>
        <div className="grid-item meta-ads">
          <div className="grid-item-header">
            {metaAds} <p>Meta Ads</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">Meta Ads ID</p>
            <input type="text" id="metaId" name="meta_id" value={metaId} onChange={handleMetaIdChange} onBlur={handleMetaIdBlur}></input>
          </div>
          <div className="bot-input-field">
            <div className="bottom-label">
              <span className="input-label">Facebook Objective</span>
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="Here you can set the objective for facebook conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
                inline={true}
                />
            </div>
            <div className="select-wrapper">
              <select name="facebook_conversion_objective" value={facebookObjective} onChange={handleFacebookObjectiveChange}>
                {Object.keys(context.facebook_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = context.facebook_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {objectiveName.split("_").join(" ").replace(/^\w/, (c) => c.toUpperCase())}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="grid-item tik-tok-ads">
          <div className="grid-item-header">
            {tiktokAds} <p>TikTok Ads</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">TikTok Ads ID</p>
            <input type="text" id="tiktokId" name="tiktok_id" value={tiktokId} onChange={handleTiktokIdChange} onBlur={handleTiktokIdBlur}></input>
          </div>
          <div className="bot-input-field">
            <div className="bottom-label">
              <span className="input-label">TikTok Objective</span>
              <CustomTooltip
                  faClass="far fa-question-circle pl-2"
                  message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
                  inline={true}
                />
            </div>
            <div className="select-wrapper">
              <select name="tiktok_conversion_objective" value={tiktokObjective} onChange={handleTiktokObjectiveChange}>
                {Object.keys(context.tiktok_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = context.tiktok_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {objectiveName.split("_").join(" ").replace(/^\w/, (c) => c.toUpperCase())}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="grid-item semrush">
          <div className="grid-item-header">
            {semrush} <p>SEMRush</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">SEMRush Target Location:</p>
            <div className="select-wrapper">
              <select name="semrush_target_location" value={semrushTargetLocation} onChange={handleSemrushTargetLocationChange}>
                <option disabled hidden>
                  Target Location
                </option>
                <option value="local">Local</option>
                <option value="regional">Regional</option>
                <option value="national">National</option>
              </select>
            </div>
          </div>
          <div className="bot-input-field">
          <div className="bottom-label">
              <span className="input-label">SEMRush ID</span>
              <CustomTooltip
                  faClass="far fa-question-circle pl-2"
                  message={semrushExample}
                  inline={true}
                />
            </div>
            <input type="text" name="semrush_id" value={semrushId} onChange={handleSemrushIdChange} onBlur={handleSemrushIdBlur}></input>
          </div>
        </div>
        <div className="grid-item-large shopify">
          <div className="grid-item-header">
            {shopifyIcon} <p>Shopify</p>
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Shopify URL
            </p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="List your shopify URL below and also select whether you want to pull shopify sales data from only `Online Store` or `All Sales Channels`"
              inline={true}
            />
            <input type="text" id="shopifyUrl" name="shopify_url" value={shopifyUrl} onChange={handleShopifyUrlChange} onBlur={handleShopifyUrlBlur}></input>
          </div>
          <div className="mid-input-field">
            <p className="input-label-2">Shopify revenue type</p>
            <div className="radio-buttons-1">
              <input
                name="shopify_revenue_type"
                value="online_store"
                type="radio"
                id="shopify_revenue_type_0"
                checked={shopifyRevenueType === "online_store"}
                onChange={handleShopifyRevenueTypeChange}
              />
              <label htmlFor="shopify_revenue_type_0">Online Store Sales Only</label>
            </div>
            <div className="radio-buttons-2">
              <input
                name="shopify_revenue_type"
                value="overall"
                type="radio"
                id="shopify_revenue_type_1"
                checked={shopifyRevenueType === "overall"}
                onChange={handleShopifyRevenueTypeChange}
              />
              <label htmlFor="shopify_revenue_type_1">All Sales Channels</label>
            </div>
          </div>
          <div className="bot-input-field row-to-col gap-24">
            <div>
              <p className="input-label">Shopify Country Filter</p>
              <div className="select-wrapper">
                <select name="shopify_country_filter" value={shopifyCountryFilter} onChange={handleShopifyCountryFilterChange}>
                  {["none", "US", "CA"].map((country) => {
                    return (
                      <option key={country} value={country}>
                        {country === "none" ? "None (pull everything)" : country}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            {jsDig(["shopify_token"], context.client_account) ? (
              <div className="shopify-authentication">
                <button type="button" className="red-button auth-button" onClick={resetShopifyToken}>
                  Reset Token
                  <CustomTooltip faClass="far fa-question-circle f18 pl-2" message={"Resetting Shopify token will require you to authenticate again"} inline={true} />
                </button>
              </div>
            ) : (context.client_account.shopify_url && context.client_account.shopify_url != "") ? (
              <div className="shopify-authentication">
                <button type="button" className="green-button auth-button"  onClick={authenticateShopifyFunction}>
                  Authenticate
                  <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
                </button>
              </div>
            ) : (
              <div className="shopify-authentication">
                <p>Shopify URL required to authenticate</p>
              </div>
            )}
          </div>
        </div>
        <div className="grid-item-large google-sheets">
          <div className="grid-item-header">
            {googleSheetsIcon} <p>Google Sheets</p>
          </div>
          <div className="top-input-field">
            <p><small>Create a copy of this <a href="https://docs.google.com/spreadsheets/d/1_pwmMmoaFKk9C8dr1eTduvN-bOnHVC_d94BYocDaK1E/edit#gid=0" target="_blank">template</a>.</small></p>
            <p><small>Data imported from sheet below will appear on the Overview dashboard</small></p>
            <p className="input-label mt-2">Spreadsheet url:</p>
            <input type="text" id="googleSheetsUrl" name="google_sheets_url" value={googleSheetsUrl} onChange={handleGoogleSheetsUrlChange} onBlur={handleGoogleSheetsUrlBlur} ></input>
          </div>
          <div className="mid-input-field">
            <div className="mb-2 d-flex gap-24">
              <button type="button" className="lite-btn btn-success text-center" onClick={(e) => pullGoogleSheetsData(e)}>
                Pull data
              </button>
              <button type="button" className="lite-btn text-center btn-danger" onClick={(e) => deleteGoogleSheetsData()}>
                Delete data
                <CustomTooltip
                  faClass="text-white far fa-question-circle f18 pl-2"
                  message={`Press this button to delete all imported Google sheets data for this client.`}
                  inline={true}
                />
              </button>
            </div>
          </div>
        </div>
        <div className="grid-item-large amazon-ads">
          <div className="grid-item-header">
            {amazonAdsIcon} <p>Amazon Ads</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">Amazon Ads ID</p>
            <p>Please select an account from the list below</p>
            <div className="select-wrapper">
              <select id="amazonAdsId" name="amazon_ads_id" value={amazonAdsId} onChange={handleAmazonAdsIdChange} onBlur={handleAmazonAdsIdBlur}>
                <option value="">None</option>
                {context.amazon_profile_ids.map((id) => {
                  return (
                    <option key={id["id"]} value={id["id"]}>
                      {`${id["name"]} - ${id["country"]} - ${id["id"]}`}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="grid-item-large amazon-seller">
          <div className="grid-item-header">
            {amazonSellerIcon} <p>Amazon Seller Central</p>
          </div>
          <div className="top-input-field">
            <p className="input-label">Select the country you would like to authenticate with:</p>
            <div className="row-to-col justify-content-space-between mb-3 gap-24">
              <div className="select-wrapper mb-2">
                <select id="amazonSellerCountry" name="amazon_seller_country" value={amazonSellerCountry} onChange={handleAmazonSellerCountryChange}>
                  {amazonSellerCountries.map((country) => {
                    return (
                      <option key={country.value} value={country.value}>
                        {`(${country.value}) - ${country.name}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <button type="button" className="green-button" onClick={() => authorizeAmazonSeller()}>
                Authenticate
                <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
              </button>
            </div>
            <div className="reload-msg" id="amazon-seller-reload-msg">
              <p>If authentication was successful you will see it on this page when you reload.</p>
            </div>
          </div>
          <div className="mid-input-field">
            <p className="input-label-2">
              <b>Current Authentications:</b>
            </p>
            {context.amazon_seller_credentials.map((cred) => {
              return (
                <div className="amazon-seller-authentication lite-flexbox justify-content-space-between mb-2" key={cred["id"]}>
                  <p>
                    {`${cred["country"]}`} - <b>{`${jsDig(["platform_ids", `amazon_seller_${cred["country"]}`], context.client_account)}`}</b>
                  </p>
                  <button type="button" className="lite-btn text-center btn-danger" onClick={(e) => deauthorizeAmazonSeller(cred["id"], e.target)}>
                    Deauthorize
                    <CustomTooltip
                      faClass="text-white far fa-question-circle f18 pl-2"
                      message={`If you deauthorize you will need to reauthorize before you can pull data from this country again.`}
                      inline={true}
                    />
                  </button>
                </div>
              );
            })}
            {context.amazon_seller_credentials.length === 0 && <p>None</p>}
          </div>
        </div>
        <div className="grid-item-large mailchimp">
          <div className="grid-item-header">
            {mailchimpIcon} <p>Mailchimp</p>
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Server prefix:
            </p>
            <CustomTooltip
              faClass="far fa-question-circle f18 pl-2"
              message={`The server prefix is the subdomain of your Mailchimp account. For example, if your Mailchimp account is located at "https://us20.admin.mailchimp.com/", then your server prefix is "us20".`}
              inline={true}
            />
            <input type="text" id="mailchimpServerPrefix" name="mailchimp_server_prefix" value={mailchimpServerPrefix} onChange={handleMailchimpServerPrefixChange} onBlur={handleMailchimpServerPrefixBlur} ></input>
            <div className="reload-msg" id="mailchimp-reload-msg">
              <p>If authentication was successful you will see it on this page when you reload.</p>
            </div>
          </div>
          <div className="mid-input-field">
            <div className="mb-2 d-flex gap-24">
              {context.mailchimp_credentials.map((cred) => {
                return (
                  <button key={cred["id"]} type="button" className="lite-btn text-center btn-danger" onClick={(e) => deauthorizeMailchimp(cred["id"], e.target)}>
                    Deauthorize
                    <CustomTooltip
                      faClass="text-white far fa-question-circle f18 pl-2"
                      message={`If you deauthorize you will need to reauthorize before you can pull data from Mailchimp again.`}
                      inline={true}
                    />
                  </button>
                );
              })}
              {context.mailchimp_credentials.length === 0 && (
                <button type="button" className="lite-btn btn-success" onClick={() => authorizeMailchimp()}>
                  Authenticate
                  <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
